import React, { useEffect, useState } from "react";
import { SignalPulse } from "./SignalPulse";
import { useNavigate } from "react-router-dom";
import { Loader2, Users, MessageSquare } from "lucide-react";
import api from "../lib/api";
import { Avatar } from "./Media";
import { FavoriteButton } from "./FavoriteButton";

// Your private collection of favorited sovereigns. Only you can see it.
export const InnerCircle = () => {
  const [members, setMembers] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/members/favorites").then(({ data }) => setMembers(data)).catch(() => setMembers([]));
  }, []);

  const removed = (id) => setMembers((prev) => (prev || []).filter((m) => m.id !== id));

  return (
    <div data-testid="inner-circle-section">
      <div className="flex items-center gap-2 mb-1">
        <Users size={16} className="text-[#14A89A]" />
        <h2 className="font-heading text-lg text-white">Inner Circle</h2>
        {members && members.length > 0 && <span className="font-body text-xs text-zinc-500">· {members.length}</span>}
      </div>
      <p className="font-body text-xs text-zinc-500 mb-5">The sovereigns you've drawn close. Private to you.</p>

      {members === null ? (
        <div className="flex justify-center py-10"><SignalPulse size={38} /></div>
      ) : members.length === 0 ? (
        <p className="font-body text-sm text-zinc-600 py-6" data-testid="inner-circle-empty">
          No one here yet. Tap the heart on a sovereign's profile or card to add them to your circle.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {members.map((m) => (
            <div key={m.id} onClick={() => navigate(`/profile/${m.id}`)} role="button" tabIndex={0} data-testid="inner-circle-card" className="relative flex items-start gap-3 bg-[#121212] border border-white/10 p-4 hover:border-white/25 transition-colors cursor-pointer group">
              <Avatar name={m.name} src={m.avatar} size={40} />
              <div className="min-w-0 flex-1 pr-14">
                <div className="font-heading text-sm text-white group-hover:text-[#14A89A] transition-colors truncate">{m.name}</div>
                <div className="font-body text-xs text-zinc-500 truncate">{m.headline}</div>
              </div>
              <div className="absolute top-3 right-3 flex items-center gap-2">
                <button
                  onClick={(e) => { e.stopPropagation(); navigate(`/messages/${m.id}`); }}
                  data-testid={`inner-circle-dm-${m.id}`}
                  title={`Message ${m.name}`}
                  className="text-zinc-500 hover:text-[#14A89A] transition-colors"
                >
                  <MessageSquare size={16} strokeWidth={1.75} />
                </button>
                <FavoriteButton memberId={m.id} initial={true} size={16} onChange={(f) => { if (!f) removed(m.id); }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
